import BaseModel from '@core/model';

import BrokerApi from '@packages/brokers/api';

export class Broker extends BaseModel {
    static name = 'Broker';
    static entity = 'brokers';
    static Api = BrokerApi;

    static fields() {
        return {
            id: this.attr(null),
            name: this.string('')
        };
    }
}

export default Broker;
